// extracted by mini-css-extract-plugin
module.exports = {"titleSection":"Tnc_titleSection__2sH1c","tncSection":"Tnc_tncSection__3DQ_m","tncItem":"Tnc_tncItem__3qpfU"};